import {setReadOffCanvasIsActive, setWatchOffCanvasIsActive} from "../../../Features/Misc/navBarSlice";
import {useDispatch} from "react-redux";

import FaveHeart from "../../Components/FaveHeart";
import {setActiveRead, setActiveWatch} from "../../../Features/Misc/activeSlice";
import stripHtml from "../../Components/StripHTML";
import React from "react";

import defaultSleepImage1 from "../../../assets/default-images/default-sleep-image-1.png";
import defaultSleepImage2 from "../../../assets/default-images/default-sleep-image-2.png";
import defaultSleepImage3 from "../../../assets/default-images/default-sleep-image-3.png";
import defaultSleepImage4 from "../../../assets/default-images/default-sleep-image-4.png";
import defaultSleepImage6 from "../../../assets/default-images/default-sleep-image-6.jpg";
import defaultSleepImage7 from "../../../assets/default-images/default-sleep-image-7.jpg";
import defaultSleepImage8 from "../../../assets/default-images/default-sleep-image-8.jpg";
import defaultSleepImage9 from "../../../assets/default-images/default-sleep-image-9.jpg";
import defaultSleepImage10 from "../../../assets/default-images/default-sleep-image-10.jpg";


export default function ReadFeaturedCard(props) {
    const dispatch = useDispatch()

    const defaultImgChoice = [
        defaultSleepImage1,
        defaultSleepImage2,
        defaultSleepImage3,
        defaultSleepImage4,
        defaultSleepImage6,
        defaultSleepImage7,
        defaultSleepImage8,
        defaultSleepImage9,
        defaultSleepImage10
    ];

    const randomImgNumber = Math.floor(Math.random() * 9);



    const {
        imgSrc,
        title,
        text,
        authorName,
        date,
        mediaType,
        mediaId
    } = props

    const readPayload = {
        imgSrc,
        title,
        text,
        authorName,
        date,
        mediaType,
        mediaId
    }

    {
        stripHtml(text.length > 120 ? text.slice(0, 120) + "..." : text)
    }

    const handleCardClick = React.useCallback(() => {
        dispatch(setReadOffCanvasIsActive());
        dispatch(setActiveRead(readPayload));
    }, [dispatch, readPayload]);

    const imageUrl = imgSrc || defaultImgChoice[randomImgNumber];

    const displayName = authorName ? (authorName === 'wesley@hydra' ? 'Sleep Geek' : authorName) : 'Sleep Geek';

    return (
        <div className="pr-2">
            <div onClick={handleCardClick}
                 className={`readFeaturedCard w-full h-64 xl:h-76 bg-pink-dashboard rounded-lg p-4 grid grid-cols-24 grid-rows-24 cursor-pointer hover:opacity-60 transition-opacity duration-300`}>


                <div
                    className="readFeaturedCard-image col-start-1 col-end-20 xs:col-end-13 row-start-1 row-end-14 xs:row-end-25 object-fill rounded-lg bg-cover no-repeat bg-center"
                    style={{backgroundImage: `url(${imageUrl}`}}
                />

                <div className="readFeaturedCard-favourite col-start-23 col-end-25 row-start-1 row-end-2">
                    <FaveHeart type={"Read"} mediaId={mediaId} mediaType={mediaType}/>
                </div>

                <div
                    className="readFeaturedCard-title text-sm lg:text-xl cursor-pointer col-start-1 col-end-24 xs:col-start-14  row-start-15 row-end-19 xs:row-start-5 xs:row-end-10 text-white"
                    onClick={() => {
                        dispatch(setReadOffCanvasIsActive());
                        dispatch(setActiveRead(readPayload));
                    }}
                >
                    <p className={`hidden xs:block`}>{stripHtml(title.length > 40 ? title.slice(0, 48) + "..." : title)}</p>
                    <p className={`xs:hidden`}>{stripHtml(title.length > 35 ? title.slice(0, 40) + "..." : title)}</p>
                </div>

                <div
                    className="readFeaturedCard-text text-xs lg:text-sm col-start-1 col-end-24 xs:col-start-14  row-start-19 row-end-23 xs:row-start-12 xs:row-end-18 text-white">
                    <p className={`hidden xs:block 3xl:hidden`}>{stripHtml(text.length > 180 ? text.slice(0, 90) + "..." : text)}</p>
                    <p className={`hidden 3xl:block`}>{stripHtml(text.length > 200 ? text.slice(0, 100) + "..." : text)}</p>
                    <p className={`xs:hidden`}>{stripHtml(text.length > 130 ? text.slice(0, 65) + "..." : text)}</p>
                </div>

                <div
                    className="readFeaturedCard-author grid grid-cols-24 items-center col-start-1 col-end-24 xs:col-start-14  row-start-23 row-end-25 xs:row-start-22 xs:row-end-25 text-white">
                    <div
                        className="readFeaturedCard-details-author-avatar w-6 h-6 3xl:w-8 3xl:h-8 rounded-full bg-gold-accent col-start-1 col-end-4  "/>
                    <div
                        className="readFeaturedCard-details-author-name font-semibold text-xs col-start-5 col-end-12 text-white">
                        {displayName}
                    </div>
                </div>
            </div>
        </div>
    );
}

